module.exports = __webpack_public_path__ + "img/p2-bg.c8372313.webp";